import { render, staticRenderFns } from "./expand_button.vue?vue&type=template&id=247f3484&"
import script from "./expand_button.vue?vue&type=script&lang=js&"
export * from "./expand_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports